import { render, staticRenderFns } from "./oftenPassenger.vue?vue&type=template&id=9760714e&scoped=true&"
import script from "./oftenPassenger.vue?vue&type=script&lang=js&"
export * from "./oftenPassenger.vue?vue&type=script&lang=js&"
import style0 from "./oftenPassenger.vue?vue&type=style&index=0&id=9760714e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9760714e",
  null
  
)

export default component.exports